// modules/Title/TitleBackground.js
// 标题场景背景模块

import BackgroundHelper from '../BackgroundHelper.js';
import UIStyleHelper from '../UIStyleHelper.js';

export default class TitleBackground {
    constructor(scene) {
        this.scene = scene;
        this.stars = [];
        this.titleText = null;
        this.subtitleText = null;
    }
    
    /**
     * 创建背景
     */
    create() {
        this.scene.cameras.main.backgroundColor = Phaser.Display.Color.ValueToColor(0x0a0a18);
        
        this.createGradientBackground();
        this.createStarBackground();
        this.createTitleBanner();
    }
    
    createGradientBackground() {
        try {
            BackgroundHelper.createGradientBackground(this.scene, {
                startColor: { r: 8, g: 12, b: 40 },
                endColor: { r: 20, g: 8, b: 28 },
                direction: 'vertical'
            });
        } catch (error) {
            // 渐变背景失败时跳过
        }
    }
    
    createStarBackground() {
        this.stars = [];
        try {
            const { width, height } = this.scene.cameras.main;
            for (let i = 0; i < 80; i++) {
                const star = this.scene.add.circle(
                    Math.random() * width,
                    Math.random() * height * 0.7,
                    Math.random() * 1.5 + 0.5,
                    0xffffff
                );
                star.alpha = Math.random() * 0.6 + 0.2;
                star.speed = Math.random() * 0.15;
                star.flickerRate = Math.random() * 2000 + 800;
                star.lastFlicker = 0;
                star.baseAlpha = star.alpha;
                star.setScrollFactor(0);
                star.setDepth(1);
                this.stars.push(star);
            }
        } catch (error) {
            // 星空创建失败时跳过
        }
    }

    createTitleBanner() {
        const cx = this.scene.cameras.main.centerX;
        const font = UIStyleHelper.PIXEL_FONT;

        const panel = this.scene.add.graphics();
        panel.fillStyle(0x000000, 0.55);
        panel.fillRect(cx - 200, 40, 400, 72);
        panel.lineStyle(2, 0x4cc9f0, 1);
        panel.strokeRect(cx - 200, 40, 400, 72);
        panel.setScrollFactor(0);
        panel.setDepth(5);

        this.titleText = this.scene.add.text(cx, 58, '老四机兵', {
            fontSize: '28px',
            fill: '#4cc9f0',
            fontFamily: font,
            fontStyle: 'bold'
        }).setOrigin(0.5).setScrollFactor(0).setDepth(6);

        this.subtitleText = this.scene.add.text(cx, 92, '废土世界的战车传说', {
            fontSize: '12px',
            fill: '#aaaaaa',
            fontFamily: font
        }).setOrigin(0.5).setScrollFactor(0).setDepth(6);
    }
    
    updateStarBackground(time) {
        if (this.stars && this.stars.length > 0) {
            this.stars.forEach(star => {
                try {
                    star.y += star.speed;
                    if (star.y > this.scene.cameras.main.height) {
                        star.y = 0;
                        star.x = Math.random() * this.scene.cameras.main.width;
                        star.baseAlpha = Math.random() * 0.6 + 0.2;
                    }
                    if (time - star.lastFlicker > star.flickerRate) {
                        star.alpha = star.baseAlpha * (0.5 + Math.random() * 0.5);
                        star.lastFlicker = time;
                    }
                } catch (error) {
                    // 单颗星更新失败时跳过
                }
            });
        }
    }
}
